import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { URL, colors } from "../utils/constant";
import usePatientDetails from "../data/talons/PatientDetails/usePatientDetails";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { getLanguage } from "../data/selector/language.selector";

export default function Header() {
  const { SubjectDetails, fetchPatientDetails } = usePatientDetails();
  const Language = useSelector(getLanguage);

  return (
    <Box sx={{ flexGrow: 0, minHeight: 0 }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: colors.headerBlueBackgound,

          boxShadow: [
            "0 1px 4px hsla(214, 53%, 23%, 0.2)",
            "0 3px 8px hsla(214, 53%, 23%, 0.2)",
            "0 4px 13px hsla(214, 53%, 23%, 0.2)",
          ],
          zIndex: 4,
          // boxShadow: "none",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography variant="h6" component="div">
            {/*logo*/}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", p: 1.5 }}>
            <Typography variant="p" sx={{ color: colors.white }}>
              {/* <Typography variant="p" sx={{ color: colors.text }}> */}
              {Language?.NavbarTitle.patient_num}{" "}
              <span className="fw-bold">{SubjectDetails?.SubjectInfoId}</span>
            </Typography>
            <Typography variant="p" sx={{ ml: 2, color: colors.white }}>
              {/* <Typography variant="p" sx={{ ml: 2, color: colors.text }}> */}
              {Language?.NavbarTitle.protocol_num}{" "}
              <span className="fw-bold">{SubjectDetails?.ProtocolNo}</span>
            </Typography>
            <Typography
              variant="p"
              sx={{ ml: 2, color: colors.white, fontWeight: "bold" }}
              // sx={{ ml: 2, color: colors.text, fontWeight: "bold" }}
            >
              {format(new Date(), "cccc, MMMM dd, yyyy hh:mm:ss a")}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
